import React from "react";
import { Avatar } from "ui-components";
import { Box, Flex, Text } from "ui-components";
import { iconThemes } from "ui-components/theme";
import { ReactComponent as EditIcon } from "assets/icons/icon-edit.svg";
import { PaymentCardTypes } from "components/PaymentCardDetails";
import { ChevronRight, Circle, IconStack, Information } from "components/Icons";
import FormattedMessage from "components/FormattedMessage";
import { gotoUrl } from "utils/helpers";
import Alert from "react-s-alert";
import get from "lodash/get";
import isFunction from "lodash/isFunction";

const DetailBox = ({
  header,
  content,
  type,
  icon,
  generic,
  userImageUrl,
  userProfileDetails,
  userDetails,
  path,
  phoneNumber,
  reload,
  action,
  isActiveTelcoUser,
  themeColors,
  showContactCSInfoIcon = false,
  honorific,
  mobileNoLabel,
  locale,
  loggedInEmail,
  ...rest
}) => {
  const iconColor = get(themeColors, "primary", iconThemes.povoyellow);
  const iconForeColor = get(themeColors, "secondary", iconThemes.povodarkgray);

  const cardTypes = get(generic, "payment_cards", {});
  const {
    cardType,
    cardDetails,
    userName,
    userNumber,
    address,
    userEmail = loggedInEmail
  } = userProfileDetails || {};

  const onClickEvent = () => {
    const onClickAction = action && get(rest, action);
    if (isFunction(onClickAction)) return onClickAction();

    if (type === "email" && !phoneNumber) {
      Alert.error(
        get(
          locale,
          "add_phone_number_to_update_email",
          "To update email you need to add a phone number first"
        )
      );
    } else {
      path && gotoUrl(path, false, {}, reload);
    }
  };
  const renderDebitCard = () => {
    return (
      <>
        <Box width={1}>
          <Flex>
            <Box width={0.9}>
              <Text fontWeight="900" size="sm" marginBottom="5px">
                {header && <FormattedMessage id={header}></FormattedMessage>}
              </Text>
              <Flex alignItems="center" marginLeft="0">
                <PaymentCardTypes
                  types={cardTypes}
                  display="single"
                  isEnabled
                  imageClass={true}
                  typeOfCard={cardType}
                />
                <Text>{cardDetails && `XXXX-XXXX-XXXX-${cardDetails}`}</Text>
              </Flex>
            </Box>
            {isActiveTelcoUser && (
              <Box onClick={onClickEvent} sx={{ cursor: "pointer" }}>
                <EditIcon />
              </Box>
            )}
          </Flex>
        </Box>
      </>
    );
  };

  const renderCommonCardWithIcon = () => {
    const contentFormatted = type === "email" ? userEmail : content;
    return (
      <>
        <Box width={0.9}>
          <Text fontWeight="900" size="sm" marginBottom="5px">
            {header && <FormattedMessage id={header}></FormattedMessage>}
          </Text>
          {contentFormatted && (
            <Text>
              <FormattedMessage id={contentFormatted}></FormattedMessage>
            </Text>
          )}
        </Box>

        {icon === "edit" ? (
          type === "email" && !phoneNumber ? null : (
            <Box onClick={onClickEvent} sx={{ cursor: "pointer" }}>
              <EditIcon />
            </Box>
          )
        ) : (
          icon === "arrow" && (
            <Box onClick={onClickEvent} sx={{ cursor: "pointer" }}>
              <ChevronRight color={"black"} />
            </Box>
          )
        )}
      </>
    );
  };

  const renderProfileImageWithName = () => {
    return (
      <Box width={1}>
        <Flex alignItems="center">
          <Box width={0.15} marginRight="0.5rem">
            <Avatar
              src={
                userImageUrl
                  ? userImageUrl
                  : "https://storage.googleapis.com/pidgc-ecom/assets/images/profile-icon.png"
              }
              onClick={onClickEvent}
              data-testid="profile-image"
              style={{
                cursor: "pointer",
                marginLeft: "0",
                borderColor: "#FFFFFF",
                boxShadow: "0 0px 0px 0 rgba(0,0,0,0)",
                flexShrink: "0",
                height: "48px",
                marginRight: "10px",
                marginTop: "2px",
                padding: "0",
                width: "48px"
              }}
            />
          </Box>
          <Box width={0.75}>
            <Text fontWeight="900" size="sm" marginBottom="5px">
              {userName} {honorific && <FormattedMessage id={honorific} />}
            </Text>
            <Text>
              {mobileNoLabel && <FormattedMessage id={mobileNoLabel} />}{" "}
              {userNumber}
            </Text>
          </Box>
          {showContactCSInfoIcon && (
            <Box
              height={16}
              width={16}
              onClick={onClickEvent}
              sx={{ cursor: "pointer" }}
            >
              <IconStack size="16px">
                <Circle size="14px" color={iconForeColor} />
                <Information color={iconColor} size="16px" />
              </IconStack>
            </Box>
          )}
        </Flex>
      </Box>
    );
  };

  const renderAddress = () => {
    return (
      <>
        {address && (
          <Box width={1}>
            <Flex>
              <Box width={0.9}>
                <Text>{address}</Text>
              </Box>
              {showContactCSInfoIcon && (
                <Box
                  height={16}
                  width={16}
                  onClick={onClickEvent}
                  sx={{ cursor: "pointer" }}
                >
                  <IconStack size="16px">
                    <Circle size="14px" color={iconForeColor} />
                    <Information color={iconColor} size="16px" />
                  </IconStack>
                </Box>
              )}
            </Flex>
          </Box>
        )}
      </>
    );
  };

  return (
    <Box
      color="blue.4"
      fontWeight="500"
      sx={{
        marginBottom: "15px",
        padding: "10px"
      }}
    >
      <Flex>
        {type === "card"
          ? renderDebitCard()
          : type === "profile"
          ? renderProfileImageWithName()
          : type === "address"
          ? renderAddress()
          : renderCommonCardWithIcon()}
      </Flex>
    </Box>
  );
};

export default DetailBox;
